import LandingSection from "./LandingSection";
import ProjectsSection from "./ProjectsSection";
import Promotion from "./Promotion";
import DownloadApp from "./DownloadApp";
import ComingSoon from "./ComingSoon";
import BlogSection from "./BlogSection";
import FaqSection from "./FaqSection";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Home() {
  const location = useLocation();
  
    useEffect(() => {
      if (location.hash) {
        const id = location.hash.replace('#', '');
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    }, [location]);
    
  return (
    <main>   
      <LandingSection />
      <ProjectsSection />
      {/*<Promotion />*/}
      <FaqSection />
      
      <DownloadApp />
      
      <ComingSoon/>
      <BlogSection />
    
    </main>
  );
}

export default Home;
